import { Text } from '@chakra-ui/react';
import React, { useState } from 'react';

import { Button } from '@chakra-snippets/button';
import {
  DialogRoot, DialogActionTrigger, DialogContent, DialogHeader, DialogBody, DialogFooter,
} from '@chakra-snippets/dialog';

interface DeleteGroupDialogProps {
  isOpen: boolean;
  onOpenChange: (value: { open: boolean }) => void;
  onDelete: () => void;
}

const DeleteGroupDialog = ({
  isOpen,
  onOpenChange,
  onDelete,
}: DeleteGroupDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    setIsDeleting(true);
    await onDelete();
    setIsDeleting(false);
  };

  return (
    <DialogRoot role="alertdialog" open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>Confirm Delete Group</DialogHeader>
        <DialogBody>
          <Text>All deletes are permanent and you won&apos;t be able to retrieve the group.</Text>
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant="outline">Cancel</Button>
          </DialogActionTrigger>
          <DialogActionTrigger asChild>
            <Button colorPalette="red" loading={isDeleting} onClick={handleDelete}>Delete Group</Button>
          </DialogActionTrigger>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default DeleteGroupDialog;
